import { httpClient } from "../../../shared/api";

export const tasksApi = {
  getById(taskId) {
    return httpClient.get(`/tasks/${taskId}`);
  },
};
